import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './index.styl'

const MonthlyRevenue = ({ pageData }) => {
  return (
    <div className="monthly-revenue">
    </div>
  )
}

MonthlyRevenue.propTypes = {}

export default MonthlyRevenue
